<template>
  <page-view title="单位查询">
    <a-card>
      <a-row class="mb-5" type="flex" align="middle">
        <a-col :span="16">
          <a-form layout="inline">
            <a-form-item>
              <span class="size5 color-black"><span style="color: red;font-size: 25px">{{ unit.unitName }}</span>关联单位列表</span>
            </a-form-item>
          </a-form>
        </a-col>
        <a-col :span="8" class="text-right">
          <a-form-item>
            <a-button type="primary" icon="rollback" @click="$router.go(-1)">返回</a-button>
            <a-button type="primary" class="ml-2" icon="plus" @click="addUnitItem">添加子单位
            </a-button>
          </a-form-item>
        </a-col>
      </a-row>
      <s-table ref="table"
               :columns="columns"
               :rowKey="record => record.id"
               :data="loadData"
               :pagination="{ showTotal: (total) => `共 ${total} 条` }"
               class="border"
               size="middle">
        <template slot="action" slot-scope="text, record">
          <a-popconfirm title="是否确认删除?" @confirm="onDelete(record)">
            <a class="color-ash" href="#">删除</a>
          </a-popconfirm>
        </template>
      </s-table>
    </a-card>
    <add-unit-item-modal ref="unitItemModal" :visible="showUnitItemModal" @cancel="showUnitItemModal = false"
                         @success="OnSuccessUnitModal"/>
  </page-view>
</template>

<script>
import { PageView } from '@/layouts'
import AddUnitItemModal from './AddUnitItemModal'
import STable from '@/components/Table'
import { QueryUnitItem, GetUnit, DelUnitItem } from './api/UnitRequest'

export default {
  name: 'QueryUnitItem',
  components: {
    PageView,
    AddUnitItemModal,
    STable
  },
  filters: {},
  data () {
    return {
      showUnitItemModal: false,
      queryForm: {
        unitId: this.$route.query.unitId
      },
      columns: [
        {
          title: '单位名称',
          ellipsis: true,
          dataIndex: 'unitName',
          align: 'left',
          scopedSlots: { customRender: 'unitName' }
        },
        {
          title: '统一信用代码',
          dataIndex: 'creditCode',
          align: 'center',
          scopedSlots: { customRender: 'creditCode' }
        },
        {
          title: '操作',
          width: '180px',
          align: 'center',
          scopedSlots: { customRender: 'action' }
        }
      ],
      unit: {},
      loadData: async parameter => {
        const params = { ...parameter, ...this.queryForm }
        return QueryUnitItem(params)
      }
    }
  },
  created () {
    this.onLoad()
  },
  methods: {
    async onLoad () {
      const that = this
      let res = await GetUnit(that.queryForm.unitId)
      that.unit = res.result
    },
    addUnitItem () {
      this.showUnitItemModal = true
    },
    OnSuccessUnitModal () {
      this.$refs.table.refresh()
      this.showUnitItemModal = false
    },
    async onDelete (record) {
      let that = this
      let res = await DelUnitItem(record.id)
      if (200 !== res.code) {
        that.$message.error('删除失败！！！')
        return
      }
      that.$message.success('删除成功！！！')
      this.$refs.table.refresh()
    },
  }
}
</script>

<style scoped>
/deep/ .f1 .ant-form-item-label {
  width: 90px;
  text-align: justify;
  text-align-last: justify;
  padding-right: 10px;
  box-sizing: border-box;
}

/deep/ .f1 .ant-form-item {
  padding-right: 40px;
}

/deep/ .f1 .ant-form-item {
  width: 100% !important;
  margin-right: 0 !important;
  display: flex;
}
</style>
